import { Dialog, DialogContent, DialogTitle, Divider, Stack, Typography } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { OpenModalHookType } from '@hooks/useOpenModal';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { hideLoader, showLoader } from '@utils/Loader';
import { showAlertError } from '@utils/Alerts/Error';
import SavedOrdersService from '@api/SavedOrders/SavedOrderCtrl';
import { SavedOrder } from '@api/SavedOrders/SavedOrder';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import LaunchIcon from '@mui/icons-material/Launch';
import { ModalConfirmation } from '@components/Utilities/Modals/ModalConfirmation';
import useConfirmationModal from '@hooks/useConfirmationModal';
interface ModalListSavedOrdersProps {
    modalListSavedOrders: OpenModalHookType;
    onTakeOrder: (order: SavedOrder) => void;
    // Sin prop lista SOLO carritos v1 (POS legacy); con 2, SOLO carritos del
    // POS 2.0 — retomar un carrito de la otra versión rompería el POS.
}
export const ModalListSavedOrders: React.FunctionComponent<ModalListSavedOrdersProps> = (props) => {
    const { modalListSavedOrders, onTakeOrder } = props;
    const savedOrdersService = useMemo(() => new SavedOrdersService(), []);
    const [savedOrders, setSavedOrders] = useState<SavedOrder[]>([]);
    const [selectedSavedOrder, setSelectedSavedOrder] = useState<SavedOrder | undefined>(undefined);
    const modalConfirmation = useConfirmationModal();
    const handleClose = () => {
        modalListSavedOrders.toggle();
    };

    const getData = async () => {
        showLoader();
        try {
            const savedOrdersData = await savedOrdersService.getSavedOrders();
            setSavedOrders(savedOrdersData);
        } catch (error: any) {
            showAlertError(error);
        }
        hideLoader();
    };

    const onSelectSavedOrder = (savedOrder: SavedOrder) => {
        onTakeOrder(savedOrder);
        handleClose();
    };

    const onDeleteSavedOrder = async () => {
        try {
            if (selectedSavedOrder?.id) {
                await savedOrdersService.deleteSavedOrder(selectedSavedOrder.id);
                void getData();
            }
        } catch (error) {
            showAlertError(error);
        }
    };

    const onConfirmDeleteSavedOrder = (savedOrder: SavedOrder) => {
        setSelectedSavedOrder(savedOrder);
        modalConfirmation.setModalData(
            'Eliminar pedido guardado',
            `Estas seguro de que deseas eliminar el pedido guardado?`
        );
    };

    useEffect(() => {
        if (modalListSavedOrders.modalOpen) {
            void getData();
        }
    }, [modalListSavedOrders.modalOpen]);

    return (
        <Dialog
            PaperProps={{
                style: { borderRadius: 25, padding: 4 }
            }}
            open={modalListSavedOrders.modalOpen}
            onClose={handleClose}
            fullWidth
            maxWidth="xs"
        >
            <DialogTitle>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="h5" fontWeight={600}>
                        Pedidos guardados
                    </Typography>
                    <IconButton color="secondary" onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <Stack spacing={2}>
                    <Divider />
                    {savedOrders.map((savedOrder, index) => (
                        <Stack key={index} direction="row" justifyContent="space-between" alignItems="center">
                            <Stack>
                                <Typography variant="body1" fontWeight={600}>
                                    {savedOrder.shoppingCart.customer?.profile?.name}
                                </Typography>
                                <Stack direction="row" spacing={2} alignItems="center">
                                    <Typography variant="body1">{`${savedOrder.shoppingCart.products?.length} producto(s)`}</Typography>
                                </Stack>
                            </Stack>
                            <Stack direction="row" spacing={2} alignItems="center">
                                <IconButton onClick={() => onSelectSavedOrder(savedOrder)}>
                                    <LaunchIcon />
                                </IconButton>
                                <IconButton onClick={() => onConfirmDeleteSavedOrder(savedOrder)}>
                                    <DeleteOutlineIcon />
                                </IconButton>
                            </Stack>
                        </Stack>
                    ))}
                    {savedOrders.length === 0 && <Typography variant="body1">No hay datos</Typography>}
                </Stack>
            </DialogContent>
            <ModalConfirmation modalConfirmation={modalConfirmation} onConfirmation={onDeleteSavedOrder} />
        </Dialog>
    );
};
